<template>
  <v-dialog v-model="dialog" max-width="500px" persistent>
    <v-card>
      <v-card-title>
        <span class="text-body-1 primary--text">Editar Perfil</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <validation-alert :validationErrors="validationErrors" />
          <v-form ref="form" v-model="isValidFormDialog" lazy-validation>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-select
                  v-model="editedItem.app_id"
                  :items="applications"
                  :rules="applicationRules"
                  item-text="name"
                  item-value="id"
                  label="Aplicación"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-text-field
                  v-model="editedItem.name"
                  :rules="nameRules"
                  label="Nombre"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-textarea
                  v-model="editedItem.description"
                  name="description"
                  label="Descripción"
                  :rules="descriptionRules"
                ></v-textarea>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-switch v-model="editedItem.active" label="Estado"></v-switch>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey" text @click="close()"> Cancelar </v-btn>
        <v-btn
          color="blue darken-1"
          :loading="isLoading"
          :disabled="isLoading"
          @click="save()"
          text
        >
          Guardar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ValidationAlert from "@/components/global/ValidationAlert.vue";
import { $EventBus } from "@/main";
export default {
  name: "EditApplicationDialog",

  props: {
    profile: Object,
  },

  data: () => ({
    isValidFormDialog: false,
    applicationRules: [(v) => !!v || "Campo requerido"],
    nameRules: [(v) => !!v || "Campo requerido"],
    descriptionRules: [(v) => !!v || "Campo requerido"],
    dialog: false,
    editedIndex: -1,
    editedItem: {
      name: "",
      app_id: "",
      description: "",
      active: null,
    },
    defaultItem: {
      name: "",
      app_id: "",
      description: "",
      active: null,
    },
    isLoading: false,
  }),

  computed: {
    applications() {
      return this.$store.getters["applications/getApplicationsList"];
    },
    validationErrors() {
      return this.$store.getters["profiles/getValidationErrors"];
    },
  },

  watch: {
    profile(val) {
      if (val && val.id) {
        this.dialog = true;
        this.editedItem = val;
        this.$store.dispatch("applications/getApplicationsList");
      }
    },
    dialog(val) {
      val || this.close();
    },
  },

  methods: {
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = { ...this.defaultItem };
        this.$store.dispatch("profiles/cleanValidationErrors");
        this.$refs.form.resetValidation();
      });
    },

    showSnack(color = "", text = "") {
      $EventBus.$emit("showSnack", { color, text });
    },

    async save() {
      if (this.$refs.form.validate()) {
        this.isLoading = true;
        try {
          await this.$store.dispatch("profiles/updateProfile", this.editedItem);
          this.showSnack("green", "Perfil actualizado");
          this.$emit("resetFilter");
          this.close();
        } catch (error) {}
        this.isLoading = false;
      }
    },
  },
   components: {
    ValidationAlert,
  },
};
</script>
